import { CoordinatorService } from './coordinator.service';
import { NotepadItem } from './notepad-item';
import { ScriptStoryItem } from './script-story-item';
import { Story } from './story';

export class StoryItem {
    id: string;
    private _body = '';

    private _notepadItemSet = new Set<string>();

    private _isEditMode = false;

    constructor(
        private coords: CoordinatorService,
        public story: Story,
        params: any,
    ) {
        this.id = params?.id || this.coords.uniqueId();
        this._body = params?.body || '';
        this._notepadItemSet = new Set(params.notepadItemLs || []);

      
    }

    

    hasNotepadItem(itm: NotepadItem) {
        return this._notepadItemSet.has(itm.id);
    }

    setNotepadItem(itm: NotepadItem, value: boolean) {
        if (value) this._notepadItemSet.add(itm.id);
        else this._notepadItemSet.delete(itm.id);
        this._store();
    }

    resetNotepadItems() {
        this._notepadItemSet.clear();
        this._store();
    }

    private _store() {
        this.coords.display$.markForCheck();
        this.story.markForManifestStore();
    }

    public get body(): string {
        return this._body;
    }
    public set body(value: string) {
        this._body = value;
        this._store();
    }

    get selectorText() {
        return this.coords.utils$.htmlTextContent(this.body);
    }

    get notepadItemIdLs() {
        return Array.from(this._notepadItemSet);
    }

    get notepadItemLs() {
        return this.coords.notepad$.notepadItemsFromId(this.notepadItemIdLs);
    }

    save() {
        return {
            id: this.id,
            body: this._body,
            notepadItemLs: Array.from(this._notepadItemSet),
            // beforeImages: this._imageBeforeLs.map((x) => x.save()),
            // afterImages: this._imageAfterLs.map((x) => x.save()),
        };
    }

    get scriptClass() {
        return new ScriptStoryItem(this.coords, this);
    }

    get isActive() {
        return this.story.currentItem === this;
    }

    get isEditMode() {
        return this._isEditMode;
    }

    set isEditMode(value: boolean) {
        this._isEditMode = value;
        this.coords.display$.markForCheck();
    }

    setActive() {
        this.story.currentItem = this;
    }

    insert(isBefore: boolean, kind = 'story-item') {
        return this.story.addItem(this, isBefore, kind);
    }

    delete() {
        this.story.deleteItem(this);
    }

    deleteNote(nt: NotepadItem) {
        this._notepadItemSet.delete(nt.id);
        this._store();
    }

    move(isUp: boolean) {
        return this.story.moveItem(this, isUp);
    }

    markForManifestStore() {
        this.story.markForManifestStore();
    }

    dialogNotepadItems() {
        this.coords.display$.dialog$.next({
            action: 'story-item-notepad-items',
            storyItem: this,
        });
    }
}
